import React from 'react'
import { css } from '@emotion/core'

import { Button } from '@/components/atoms'
import { ButtonType } from '@/components/atoms/button'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

type Props = {
  buttonType: ButtonType
  isDisabled?: boolean
  onClick: React.MouseEventHandler<HTMLButtonElement>
  children: React.ReactNode
}

export const CompletionButton: React.FC<Props> = ({ buttonType, isDisabled = false, onClick, children }) => (
  <Button
    buttonType={buttonType}
    width="auto"
    height={60}
    fontSize={22}
    borderRadius={50}
    fontWeight="normal"
    isDisabled={isDisabled}
    disabled={isDisabled}
    onClick={onClick}
    customCss={completionButtonStyle}
  >
    {children}
  </Button>
)

const completionButtonStyle = css(
  {
    boxSizing: 'border-box',
    flexShrink: 0,
    padding: '15px 32px 16px',
    fontFamily: 'Noto Sans JP, sans-serif',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: '1.1px',
    whiteSpace: 'nowrap',
    '&:focus-visible': {
      outline: '2px solid #F2A40B',
      outlineOffset: 2,
    },
  },
  createSelfCheckinResponsiveStyle({
    landscape13: {
      height: 66,
      fontSize: 26,
      letterSpacing: '1.3px',
    },
  }),
)
